


































import Vue from "vue";
import { Grid } from "@progress/kendo-vue-grid";
import PrinterSettingEdit from "@/components/PrinterSetting/PrinterSettingEdit.vue";
import PrinterSettingAdd from "@/components/PrinterSetting/PrinterSettingAdd.vue";
import { Info } from "@/models/Info";
import { Printer } from "../../models/Printer";
import { CloudSetting } from "../../models/CloudSetting";

function getNestedValue(fieldName: string, dataItem) {
  const path = fieldName.split(".");
  let data = dataItem;
  path.forEach(p => {
    data = data ? data[p] : undefined;
  });
  return data;
}
export default Vue.extend({
  props: {
    info: {
      type: Object as () => Info,
      default: null
    }
  },
  components: {
    Grid,
    PrinterSettingEdit,
    PrinterSettingAdd
  },
  computed: {
    computeDevice(): Printer[] {
      const result = this.info.cloudSettings.filter(cd => cd.deviceUDID == this.info.selectedDevice.deviceUDID)[0];
      if (result && result.printers) {
        return Object.values(result.printers);
      } else {
        return [];
      }
    },
    selectedDevice(): CloudSetting {
      return this.info.selectedDevice;
    }
  },
  data() {
    return {
      editItem: null as Printer | null,
      isEditMode: false,
      isAddMode: false,
      columns: [
        { field: "brandName", title: "Brand Name" },
        { field: "modelName", title: "Model Name" },
        { field: "printerIp", title: "Printer Ip" },
        { field: "isActive", title: "Is Active", width: "150" },
        {
          field: "Action",
          title: " ",
          width: "75"
        }
      ]
    };
  },
  methods: {
    getNestedValue,
    onEditBtnClick(dataItem: Printer): any {
      const foundItems = this.computeDevice.map(sett => {
        return sett.id;
      });
      const selectedIndex = foundItems.indexOf(dataItem.id);
      const item = this.computeDevice[selectedIndex];
      this.editItem = {
        ...item
      };
      this.isEditMode = true;
    },
    onAddBtnClick(): any {
      this.isAddMode = true;
    },
    handleEditSuccess(data: Printer) {
      this.$emit("refresh");
    }
  }
});
